import get from 'lodash/get';

const config = {
  get(key) {
    return get(window.setappConfig, key.split('.'));
  },
};

export default config;
